module.exports = __webpack_public_path__ + "img/mechanism.b75f40dd.png";